import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const mineVuex = createNamespacedHelpers("mine");
const airdropVuex = createNamespacedHelpers("airdrop");
export default {
  name: "sign",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"]),
    ...mineVuex.mapState(["hourEearnings"]),
    ...airdropVuex.mapState(["airdropList"])
  },
  data() {
    return {
      popAirdropTipShow: false,
      popBindWalletShow: false,
      popSelectTokenShow: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.popAirdropTipShow = false;
    this.popBindWalletShow = false;
    this.popWithdrawShow = false;
    this.$nextTick(() => {
      next();
    });
  },
  async mounted() {
    if (!this.hourEearnings) {
      await this.getHourEarnings();
    }
    if (this.airdropList.length == 0) {
      await this.getAirdropList();
    }
  },
  watch: {
    "userData": {
      handler() {},
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mineVuex.mapActions(["getHourEarnings"]),
    ...airdropVuex.mapActions(["getAirdropList"]),
    showTip() {
      this.popAirdropTipShow = true;
    },
    onBindWallet() {
      this.popBindWalletShow = true;
    },
    async onJoin(type, url, extra) {
      console.log("url=====", url);
      if (type == 'telegram' || type == 'channel') {
        this.WebApp.openTelegramLink(url);
      } else {
        this.WebApp.openLink(url);
      }
      if (!this.userData[`joined_${type}`]) {
        this.doCheckJoin(type);
      }
    },
    onSelectToken() {
      this.popSelectTokenShow = true;
    }
  }
};